<template>
  <div id="etnersFoot" class="footer_recruit ">
    <div class="inner_footer">
      <div class="footer_cont">
        <div class="family_sites util_cont ">
          <select class="fam" ref="familysite" @change="fnChangeFamilySite($event)">
            <option selected="" value="">FAMILY SITE</option>
            <option value=" //etners.com/">ETNERS</option>
            <option value="//sharedservice.etners.com">SHARED SERVICE</option>
            <option value="//etnerspayroll.com">PAYROLL</option>
            <option value="//gamdongtime.etnersplatform.com/">GAMDONG TIME</option>
            <option value="//esop.etners.com">ESOP</option>
            <option value="//mall.etners.com">MALL</option>
            <option value="//moving.etners.com">MOVING</option>
            <option value="//housing.etners.com">HOUSING</option>
            <option value="//relocation.etners.com">RELOCATION</option>
            <option value="//bidding.etners.com/">BIDDING</option>
            <option value="//shop.etners.com">SHOP</option>
            <option value="//etnersefs.com/landing">EFS</option>
            <option value="//esrm.etners.com">ESRM</option>
          </select>
        </div>
      </div>
      <div class="footer_info">
        <div class="footer_logo_wrap"> <img src="../assets/img/etners-main/footerImg.png" alt="etners_pcs_footer_logo"></div>
        <div>
          <a href="//etners.com/terms/management/detail/12/02" class="link_info" style="cursor:pointer"><b>개인정보처리방침</b></a>
        </div>
        경기도 성남시 분당구 대왕판교로 670 유스페이스 2-B동 7층 (우.13494)<br>
        대표전화 : 1533-4810(ARS 9번, 1번) 팩스 : 070-8806-5190
        개인정보처리방침 법적고지 이메일 무단수집거부 <small class="txt_copyright">Copyright © etners Corp. All rights reserved.</small> </div>
    </div>
  </div>
</template>
<script>
  import ApiConfig from '../api/api.config'

  export default {
    created: function () {

    },
    mounted: function () {

    },
    methods: {
      fnChangeFamilySite: function(event){
        let siteAddr = event.target.value
    		if(siteAddr !== undefined){
    			window.open(siteAddr)
    		}
    	},
      fnPopupPricavySite: function(){
        window.open('//etners.com/terms/management/detail/12/02','privacy')

      }

    },
    data: function () {

      return {

      }
    },

  }
</script>
<style scoped>

</style>
